import { Field, useField } from "formik";
import React from "react";
import BaseElement from "components/FormElements/BaseElement";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
// eslint-disable-next-line no-unused-vars
import _Mention from "quill-mention";
import { useAuth } from "hooks/Auth";
import { apiGet } from "helpers/Request";
import { transform as userTransformer } from "schemas/User";

async function suggestUsers(searchTerm, pub) {
    if (!searchTerm) {
        return [];
    }
    const items = await apiGet("/v4/search", pub, {
        keyword: searchTerm,
        per_page: 5,
        type: "user",
        includesnw: 1,
    });

    return userTransformer(items).map((item) => {
        return {
            id: item.uuid,
            value: item.slug,
        };
    });
}

export default function RichEditorInternal(props) {
    const auth = useAuth();

    const defaultProps = {
        label: "Rich Text",
        id: "rich-text",
        name: "rich-text",
        value: "",
        isError: false,
        errorText: "",
        variant: false,
        onChange: () => {},
    };
    const useProps = Object.assign(defaultProps, {}, props);
    const [field, meta] = useField(props);

    const label = (
        <label
            htmlFor={useProps.id}
            className="block text-sm font-medium text-gray-700"
        >
            {props.label}
        </label>
    );

    const input = (
        <div className="rounded bg-white shadow-sm">
            <Field name={field.name}>
                {({ field }) => (
                    <ReactQuill
                        value={field.value || ""}
                        onChange={field.onChange(field.name)}
                        modules={{
                            mention: {
                                allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                                mentionDenotationChars: ["@"],
                                source: async function (
                                    searchTerm,
                                    renderList
                                ) {
                                    const matchedPeople = await suggestUsers(
                                        searchTerm,
                                        auth.publication
                                    );
                                    renderList(matchedPeople, searchTerm);
                                },
                            },
                        }}
                    />
                )}
            </Field>
        </div>
    );

    const helperText = useProps.helpertext ? (
        <p className="mt-2 text-sm text-gray-500">{useProps.helpertext}</p>
    ) : (
        ""
    );

    const errorText =
        useProps.isError || (meta.touched && meta.error) ? (
            <p className="mt-2 text-sm text-red-600">
                {useProps.errorText}
                {meta.error}
            </p>
        ) : (
            ""
        );

    return (
        <BaseElement
            {...useProps}
            label={label}
            input={input}
            helpertext={helperText}
            errortext={errorText}
        />
    );
}
